import {lazy} from 'react';

export const FmTableLazy = lazy(() => import(/* webpackChunkName: "fmTable" */ '.'));
